import { camo } from './camo';
import { modern } from './modern';
import { retro } from './retro';
import { traditional } from './traditional';
import { patriotic } from './patriotic';
import { city } from './city';

export const basketball = {
  traditional,
  retro,
  modern,
  camo,
  patriotic,
  city,
};
